import {IBallTrajectory, ITrajectoryCoordinate} from "Data"
import {IBallTrajectoryService} from "Services"
import {Polynomium} from "MeasurementsCalculations";
import  * as BallTrajectory from "Data/IBallTrajectory";

export class BallTrajectoryService implements IBallTrajectoryService{
    /*
    generateTrajectoryPoints(param: Array<IBallTrajectory>) :  Array<ICoordinate>{
        if (param) {
            const timeIntervalArray = new Array<number>();
            var trajectoryCoordinates = new Array<ICoordinate>();
            param = param.sort((x, y) => {
                if (x.TimeInterval[0] < y.TimeInterval[0]) {
                    return -1;
                }
                if (x.TimeInterval[0] > y.TimeInterval[0]) {
                    return 1;
                }
                return 0;
            });
            for (var i = 0, l = param.length; i < l; ++i) {
                const xfit = new Polynomium(param[i].XFit);
                const yfit = new Polynomium(param[i].YFit);
                const zfit = new Polynomium(param[i].ZFit);
                const timeInterval = param[i].TimeInterval;
                timeIntervalArray.push(timeInterval[1] - timeInterval[0]);
                const currentCoordinates = this.generateTrajectoryCoordinates(xfit, yfit, zfit, timeInterval, 500);
                trajectoryCoordinates = trajectoryCoordinates.concat(currentCoordinates);
            }
            return trajectoryCoordinates;
        }
        return new Array<ICoordinate>();
    }
    */
    private generateTrajectoryCoordinates(xPolynomium: Polynomium, yPolynomium: Polynomium, zPolynomium: Polynomium, timeInterval: Array<number>, numberOfPoints: number) : Array<ITrajectoryCoordinate> {
        const data = new Array<ITrajectoryCoordinate>();
        const [startPoint, endPoint] = timeInterval;
        const delta = (endPoint - startPoint) / numberOfPoints;
        for (let i = 0; i < numberOfPoints; ++i) {
            const t = startPoint + i * delta;
            const coor: ITrajectoryCoordinate = {
                x: xPolynomium.calculateValue(t),
                y: yPolynomium.calculateValue(t),
                z: zPolynomium.calculateValue(t)
            };
            data.push(coor);
        }
        const endCoor: ITrajectoryCoordinate = {
            x: xPolynomium.calculateValue(endPoint),
            y: yPolynomium.calculateValue(endPoint),
            z: zPolynomium.calculateValue(endPoint)
        };
        data.push(endCoor);
        return data;
    }

    generateTrajectoryPoints(param: BallTrajectory.IBallTrajectory[]): ITrajectoryCoordinate[] { throw new Error("Not implemented"); }
}